import { FC } from 'react';

import { postLayoutMap } from '~postMaps';
import { PostProps } from '~types';
import { renderPostLayout } from '~utils';

export const Post: FC<PostProps> = renderPostLayout(postLayoutMap);
